<template>
  <div class="container__content">
    <div class="wrapper">
      <div class="content-7">
        <LotteryItem
          :lottery-code="lotteryCode"
          :lm-tj-data="lmTjData"
          @complete="reload"
        />
      </div>

      <div class="content-8">
        <div class="content-8__titlebar">
          <div class="content-8__titlebar__left">
            <div class="c8-titlename">
              <span class="c8-titlename__text">两面推荐</span>
            </div>
          </div>
          <div class="content-8__titlebar__right">
            <LotteryDateFilterTab
              @updateForm="updateForm"
            />
          </div>
        </div>

        <Loading v-if="isLoading" />
        <div v-if="list.length > 0 && !isLoading" class="content-8__content">
          <table v-if="!isEmpty" class="even-color">
            <thead>
              <tr>
                <th>时间</th>
                <th>期数</th>
                <th>开奖结果</th>
                <th>名次</th>
                <th>大小</th>
                <th>跟投</th>
                <th>单双</th>
                <th>跟投</th>
                <th>得分</th>
                <th>累计</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="list.length === 0">
                <td colspan="9">尚无资料</td>
              </tr>
              <tr v-for="(item, index) in list" :key="`lmtj-${index}`">
                <!-- 時間 -->
                <td v-text="formatDrawTime(item.drawTime)"></td>
                <!-- 期數 -->
                <td v-text="item.period"></td>
                <!-- 開獎結果 -->
                <td>
                  <div v-if="!item.balls" class="tableballbox"><span class="red">等待开奖</span></div>
                  <div class="tableballbox">
                    <div
                      v-for="(ball, ballIndex) in item.balls"
                      :key="`ball-${ballIndex}`"
                      class="tableballbox__item"
                    >
                      <div
                        class="ball size-middle"
                        :class="[
                          `ball-0${ball} ball-${ball}`,
                          {
                            hightlight: ballIndex === 0,
                            'color-disable': ballIndex !== 0
                          }
                        ]"
                      >
                        <span class="ball__number" v-text="ball"></span>
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  冠军
                </td>
                <!-- 大小 -->
                <td>
                  <div
                    v-for="(predict, index_predict) in item.predictions"
                    :key="`${item.period}-predict-guess-daXiao-${index_predict}`"
                  >
                    <span
                      v-text="predict.daXiao.guessLabel"
                    ></span>
                    <span
                      :class="predict.daXiao.guessClass"
                      v-text="predict.daXiao.profitLabel"
                    ></span>
                  </div>
                </td>
                <!-- 跟投 -->
                <td>
                  <span
                    v-for="(predict, index_predict) in item.predictions"
                    :key="`${item.period}-predict-cost-daXiao-${index_predict}`"
                    v-text="`${predict.daXiao.cost}分`"
                  ></span>
                </td>
                <!-- 單雙 -->
                <td>
                  <div
                    v-for="(predict, index_predict) in item.predictions"
                    :key="`${item.period}-predict-guess-danShuang-${index_predict}`"
                  >
                    <span
                      v-text="predict.danShuang.guessLabel"
                    ></span>
                    <span
                      :class="predict.danShuang.guessClass"
                      v-text="predict.danShuang.profitLabel"
                    ></span>
                  </div>
                </td>
                <!-- 跟投 -->
                <td>
                  <span
                    v-for="(predict, index_predict) in item.predictions"
                    :key="`${item.period}-predict-cost-danShuang-${index_predict}`"
                    v-text="predict.danShuang.cost"
                  ></span>
                </td>
                <!-- 得分 -->
                <td>
                  <span :class="item.profitClass" v-text="item.profitLabel"></span>
                </td>
                <!-- 累計 -->
                <td>
                  <span class="red" v-text="item.totalProfitLabel"></span>
                </td>
              </tr>
            </tbody>
          </table>
          <ClickMoreBtn v-if="moreBtnExists" :btn-hide="noMoreData" @show-more="showMoreInfo" />
        </div>

        <NoData v-if="list.length === 0 && !isLoading" />

      </div>
    </div>
  </div>
</template>

<script>
import { ruleCodeMapping } from '@/utils/lotteryDictionary'
import { getLmTj_web } from '@/api/desktop/lmTj'

import LotteryItem from '@/components/web/pages/trend/LotteryItem'
import LotteryDateFilterTab from '@/components/web/pages/trend/LotteryDateFilterTab'
import Loading from '@/components/web/common/Loading'
import NoData from '@/components/web/common/NoData'
import * as moment from 'moment-mini'
import ClickMoreBtn from '@/components/web/pages/trend/ClickMoreBtn'
import chunk from 'lodash.chunk'

export default {
  name: 'WebLmTj', // 兩面推薦 - 電腦版
  components: {
    LotteryItem,
    LotteryDateFilterTab,
    Loading,
    NoData,
    ClickMoreBtn
  },
  async asyncData({ app, params }) {
    const { lottery_code } = params
    const lotteryType = await app.$getLotteryType(lottery_code)

    return { lotteryType }
  },
  data() {
    return {
      isLoading: false,

      lotteryCode: this.$route.params.lottery_code,
      lotteryType: null,

      form: {},

      todayTotalProfit: '-',
      profitDiffToGoal: '-',

      list: [],

      chunkInfo: {
        lists: [],
        index: 0,
        last: 0,
        isLast: false
      }
    }
  },
  computed: {
    dailyFinished() {
      const profitDiffToGoal = Number(this.profitDiffToGoal)
      if (!isNaN(profitDiffToGoal) && profitDiffToGoal <= 0) {
        return true
      }
      return false
    },
    isEmpty() {
      return this.list.length === 0
    },
    lmTjData() {
      const { todayTotalProfit, profitDiffToGoal, dailyFinished } = this
      return { todayTotalProfit, profitDiffToGoal, dailyFinished }
    },
    noMoreData() {
      return this.chunkInfo.isLast
    },
    moreBtnExists() {
      return !this.isLoading && this.list.length > 0
    }
  },
  methods: {
    async reload() {
      this.list = []
      this.isLoading = true

      const { lotteryCode, form } = this
      const [data, error] = await getLmTj_web(lotteryCode, form)
      if (error) return

      const { todayTotalProfit, profitDiffToGoal, predictions: list } = data

      list.forEach((item, index) => {
        const waitDraw = (index === 0) && (item.result === 0)

        item.resultLabel = waitDraw ? '待' : item.result
        item.resultClass = item.result === 10 ? `ball-10` : `ball-0${item.result}`
        item.profitLabel = waitDraw ? '?' : item.profit
        item.totalProfitLabel = waitDraw ? '?' : item.totalProfit
        item.profitClass = item.profitLabel === '?' ? 'red' : ''

        item.predictions.forEach((predict) => {
          Object.keys(predict).forEach((key) => {
            const { win, profit } = predict[key]
            const profitAbs = Math.abs(profit)

            predict[key].guessLabel = ruleCodeMapping[predict[key].guess]
            predict[key].guessClass = waitDraw || win !== 3 ? 'red' : ''
            predict[key].profitLabel = waitDraw
              ? '?'
              : win === 3
                ? `输${profitAbs}分`
                : win === 2
                  ? `赢${profitAbs}分`
                  : ''
          })
        })
      })

      // 對資料切片，以 "顯示更多" 按鈕來決定資料呈現
      Object.assign(this.chunkInfo, this.chunkData(list))
      this.list = this.chunkInfo.lists[this.chunkInfo.index] || []

      Object.assign(this, { todayTotalProfit, profitDiffToGoal })
      this.isLoading = false
    },
    formatDrawTime(drawTime) {
      return moment(drawTime).format('YYYY-MM-DD HH:mm:ss')
    },
    updateForm(form) {
      this.form = Object.assign({}, form)
      this.reload()
    },
    resetChunkInfo() {
      Object.assign(this.chunkInfo, { lists: [], index: 0, last: 0, isLast: false })
    },
    chunkData(data) {
      const lists = chunk(data, 30)
      const index = 0
      const last = lists.length - 1
      const isLast = index >= last
      return { lists, index, last, isLast }
    },
    showMoreInfo() {
      const { last, lists } = this.chunkInfo
      this.chunkInfo.index++
      if (this.chunkInfo.index === last) {
        this.chunkInfo.isLast = true
      }
      this.list = this.list.concat(lists[this.chunkInfo.index])
    }
  }
}
</script>
